import { BroadcastChannel } from "broadcast-channel";
import { createCoreBroadcastChannelFactory } from "../broadcastChannels/coreBroadcastChannel";
export const createCoreBroadcastChannel = createCoreBroadcastChannelFactory(BroadcastChannel);
